var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.62305 8.02185C1.62305 12.9431 5.92822 17.0127 7.8338 18.573C8.10652 18.7963 8.24452 18.9093 8.44798 18.9665C8.60641 19.0112 8.83959 19.0112 8.99802 18.9665C9.20187 18.9092 9.3389 18.7973 9.61265 18.5731C11.5182 17.0128 15.8232 12.9435 15.8232 8.0223C15.8232 6.15993 15.0752 4.37362 13.7436 3.05672C12.4121 1.73982 10.6063 1 8.72323 1C6.84017 1 5.03415 1.73994 3.70262 3.05683C2.37109 4.37373 1.62305 6.15948 1.62305 8.02185Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69455 7.0858C6.69455 8.20617 7.60279 9.1144 8.72315 9.1144C9.84352 9.1144 10.7518 8.20617 10.7518 7.0858C10.7518 5.96544 9.84352 5.0572 8.72315 5.0572C7.60279 5.0572 6.69455 5.96544 6.69455 7.0858Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d82f0679591a4209466054ac9f094f13.svg";
export { ForwardRef as ReactComponent };